import React from 'react';
import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import { captureUtmTouch } from '../../lib/attribution';
import { publicTheme } from '../../theme/publicTheme';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  // Record first/last-touch UTM attribution for any public page visit; the
  // app shell stamps it onto the organization after signup.
  React.useEffect(() => {
    captureUtmTouch();
  }, []);

  return (
    <ThemeProvider theme={publicTheme}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background.default'
      }}>
        <PublicHeader />
        <Box component="main" sx={{ flexGrow: 1 }}>
          {children}
        </Box>
        <PublicFooter />
      </Box>
    </ThemeProvider>
  );
};

export default PublicLayout;
